module.exports = __webpack_public_path__ + "static/media/overlay-yellow-blue.836e5d9f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tags/overlay-yellow-blue.svg
// module id = 568
// module chunks = 0